import { useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import type { GridColDef } from "@mui/x-data-grid";
import { LATEST } from "@/api/report/_models/Report";
import { getInventoryReport } from "@/api/report/getInventoryReport";
import { getInventoryReportList } from "@/api/report/getInventoryReportList";
import { ReportView } from "./ReportView";
import { ReportSelector } from "./ReportSelector";

const COLUMNS: GridColDef[] = [
  { field: "item", headerName: "Item", width: 160 },
  { field: "warehouse", headerName: "Warehouse", width: 120 },
  { field: "description", headerName: "Description", flex: 1, minWidth: 220 },
  { field: "onHandQuantity", headerName: "On Hand", type: "number", width: 110 },
  { field: "availableToSell", headerName: "Available", type: "number", width: 110 },
  { field: "inProcessQuantity", headerName: "In Process", type: "number", width: 110 },
  { field: "heldQuantity", headerName: "Held", type: "number", width: 90 },
  { field: "demandQuantity", headerName: "Demand", type: "number", width: 100 },
];

export const InventoryReport = () => {
  const [selected, setSelected] = useState(LATEST);
  const listQuery = getInventoryReportList.useQuery();
  const reportQuery = getInventoryReport.useQuery(selected);
  const rows = reportQuery.data ?? null;

  let error: string | null = null;
  if (reportQuery.isError) {
    error = JSON.stringify(reportQuery.error);
  }

  const selector = (
    <ReportSelector
      id="inventory-report"
      files={listQuery.data ?? null}
      value={selected}
      onChange={setSelected}
    />
  );

  return (
    <ReportView
      title="Inventory report"
      loading={reportQuery.isFetching}
      error={error}
      count={rows?.length ?? null}
      action={selector}
    >
      {rows && (
        <Box sx={{ height: "calc(100vh - 220px)", width: "100%" }}>
          <DataGrid
            rows={rows.map((row, i) => ({ id: i, ...row }))}
            columns={COLUMNS}
            density="compact"
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            disableRowSelectionOnClick
          />
        </Box>
      )}
    </ReportView>
  );
};
